import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Button from '../../../UniformComponents/Button'
import Typography from '../../../UniformComponents/Typography'
import InfoAccordion from '../../InfoAccordion'

const renderError = (errorType, data) => {
    switch (errorType) {
        case 'csvValidation': {
            const {
                columnData,
                invalidColumnMapping,
                invalidColumns,
                tooManyCells,
                rows,
                cols,
            } = data

            const columnError = columnData.length > 0
                ? (
                    columnData.map(({ lineIndex, columnErrors }) => (
                        <div>
                            {i18n.t('distribute.importError.column', { line: lineIndex })}
                            <ul>
                                {Object.keys(columnErrors).map((key) => (
                                    <li>{`${key} - ${columnErrors[key]}`}</li>
                                ))}
                            </ul>
                        </div>
                    )))
                : null

            const columnMappingError = invalidColumnMapping.length > 0
                ? (
                    <div>
                        {i18n.t('distribute.importError.columnMapping')}
                        <ul>
                            {invalidColumnMapping.map((col) => (
                                <li>{col}</li>
                            ))}
                        </ul>
                    </div>
                ) : null

            const columnOptionError = invalidColumns.length > 0
                ? (
                    <div>
                        {i18n.t('distribute.importError.columnOptions')}
                        <ul>
                            {invalidColumns.map((col) => (
                                <li>{col}</li>
                            ))}
                        </ul>
                    </div>
                ) : null

            const cellCountError = tooManyCells
                ? <div dangerouslySetInnerHTML={{ __html: i18n.t('distribute.importError.tooManyCells', { rows, cols }) }} />
                : null

            return (
                <InfoAccordion cssClass="error-modal-information" title={i18n.t('errorModal.accordionTitle')} show>
                    {columnError}
                    {columnMappingError}
                    {columnOptionError}
                    {cellCountError}
                </InfoAccordion>
            )
        }
        default:
            return (
                <p className="error-modal-generic-error">{i18n.t('errorModal.genericError')}</p>
            )
    }
}

@observer
class ErrorModal extends Component {
    render() {
        const { distributeStore } = this.props
        return (
            <Modal
                show={distributeStore.errorModalVisible}
                onClose={distributeStore.hideErrorModal}
            >

                <div className="uc-modal__header">
                    <Typography type="h2">{i18n.t('errorModal.title')}</Typography>
                </div>
                <p
                    className="uc-modal__desc"
                    dangerouslySetInnerHTML={{ __html: i18n.t('errorModal.subtitle.distribute') }}
                />

                <div>
                    {renderError(distributeStore.errorType, distributeStore.errorDetails)}
                </div>

                <br />

                <ModalFooter>
                    <div className="error-modal-buttons">
                        <Button cssClass="tertiary regular" onClick={distributeStore.hideErrorModal}>
                            {i18n.t('close')}
                        </Button>

                        <Button cssClass="primary regular" onClick={distributeStore.uploadNewList} style={{ gap: 5 }}>
                            <i className="fal fa-folder-arrow-down" />

                            {i18n.t('errorModal.action')}
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>
        )
    }
}

export default ErrorModal
